module.exports = __webpack_public_path__ + "e8a92a29978352517c450b9a800b06cb.woff2";